module.exports = __webpack_public_path__ + "static/media/funTeacher.864872d4.png";